import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { BlurHashPipe } from '../../../pipes/blur-hash.pipe';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';
import { GallerySettingsGroupComponent } from '../gallery-settings-group/gallery-settings-group.component';
import { RoundedHoverBoxComponent } from '../rounded-hover-box/rounded-hover-box.component';
import { ThemeAssetPageAmbientModeItemComponent } from '../theme-asset-page-ambient-mode-item/theme-asset-page-ambient-mode-item.component';
import { ThemeAssetPageBackgroundColorItemComponent } from '../theme-asset-page-background-color-item/theme-asset-page-background-color-item.component';
import { ThemeAssetPageViewingControlsItemComponent } from '../theme-asset-page-viewing-controls-item/theme-asset-page-viewing-controls-item.component';

@Component({
  selector: 'app-theme-asset-page-customize',
  imports: [
    GallerySettingsCustomizeHeaderComponent,
    GallerySettingsGroupComponent,
    ThemeAssetPageBackgroundColorItemComponent,
    ThemeAssetPageAmbientModeItemComponent,
    ThemeAssetPageViewingControlsItemComponent,
    RoundedHoverBoxComponent,
    BlurHashPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-asset-page-customize.component.html',
  styleUrl: './theme-asset-page-customize.component.scss',
})
export class ThemeAssetPageCustomizeComponent {
  gallery = input.required<GalleryDto>();
  theme = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    return gallery.theme || calcLegacyTheme(gallery);
  });
  back = output<void>();
}
